module.exports = __webpack_public_path__ + "img/vision-2.54d29b1a.png";